<template>
  <div
    class="form-group"
    @dblclick="dblclk"
  >
    <label v-if="label">
      {{ label }}<slot />
    </label>

<!--    <date-picker v-if="type=='datetimepicker' || type=='datepicker' || type=='time'"-->
<!--        class="form-control border-input error"-->
<!--        v-bind="$props"-->
<!--        :confirm="confirm"-->
<!--        @confirm="$emit('confirm',$event)"-->
<!--        :confirmText="translate('config.apply')"-->
<!--        v-model="datepicker_data"-->
<!--        :format = format-->
<!--        :type="(type=='datetimepicker') ? 'datetime' : (type=='datepicker') ? 'date' : 'time'"-->
<!--        :range = range-->
<!--        :valueType="value_type"-->
<!--        @input="$emit('input',$event)"-->
<!--        @clear="$emit('clear',$event)"-->
<!--        @close="$emit('close',$event)"-->
<!--        @keydown="$emit('keydown',$event)"-->
<!--    />-->

    <input
      :id="id"
      :name="name"
      class="form-control border-input error"
      v-bind="$props"
      :value="value"
      :autocomplete="autocomplete"
      :class="{error:error}"
      :min="min"
      :max="max"
      @input="$emit('input',$event.target.value)"
      @keydown="$emit('keydown',$event)"
      @keyup="$emit('keyup',$event)"
      @focusout="$emit('focusout',$event)"
    >

    <span v-if="clearable && String(value).length > 0" class="mdi mdi-close clear" @click="clear_value"/>
  </div>
</template>
<script>


export default {
  data () {
    return {
      /* start_date: new Date(2021, 2, 1), */
      datepicker_data: new Date(),
    }
  },
  mounted () {
    this.datepicker_data = this.value
  },

  watch : {
    datepicker_data() {
    }
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    disabledDate:Function,
    formatter: Object,
    format: String,
    range: Boolean,
    label: String,
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number, Array],
    value_type: {
      type: String,
      default: 'X'
    },
    error: {
      type: Boolean,
      default: false
    },
    id: String,
    min: Number,
    max: Number,
    autocomplete: {
      type: String,
      default: 'off'
    },
    confirm:{
        type: Boolean,
        default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    clear_value(){
      this.$emit('input',"")
    },

    /* disabledTwoMonth(date) {
        const today = new Date();
        return date > new Date(today.getTime()) || date < new Date(today.getTime() - 60 * 24 * 3600 * 1000);
    },
 */
    dblclk () {
      if (this.type === 'text' && this.readonly) {
        if (navigator.clipboard !== undefined) {
          this.$clipboard.copy(this.value)
        } else {
          let range = document.createRange()
          window.getSelection().addRange(range)
          try {
            document.execCommand('copy')
            this.global_notify('info', this.translate('clipboard.value_save_buffer'))
          } catch (err) {
            console.log('Can`t copy')
          }
        }
      }
    }
  }
}

</script>
<style lang="scss" scoped>

  .error {
    border-color: red;
  }

  .form-group{
    position: relative;
    margin-bottom: 10px;
    .form-control{
      width: 100%;
      @media (max-width: 1600px) {
        padding: 5px 10px;
      }
    }
    span.clear{
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      right: 10px;
      bottom: 0;
      cursor: pointer;
      font-weight: bolder;
      font-size: 14px;
      &:hover{
        color: #e53935;
      }
    }
  }

  // .form-group label{
  //   font-size: 13px;
  //   margin-bottom: 0;
  // }



</style>
